const styles = () => ({
  '.dn-container': {
    position: 'relative',
    padding: '22px',

    '& > div': {
      maxWidth: '1440px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },

  '.dn-panel': {
    background: '#fff',
  },

  '.dn-panel-expiring': {
    '.MuiAlert-root': {
      background: '#FFFADF',
      padding: '0 15px',
      borderRadius: '500px',

      '.MuiAlert-message': {
        width: '100%',
        padding: '0',

        p: {
          fontWeight: '400',
          fontSize: '11px',
          lineHeight: '14px',
          color: '#4B4B4B',
        },
      },

      '.MuiAlert-icon': {
        marginRight: '5px',
        padding: '7.5px 0 !important',

        svg: {
          height: '15px',
          width: '15px',
        },
      },
    },
  },
  '.dn-toolbar-logo': {
    width: '225px',
    marginRight: '15px',
    display: 'flex',
    borderRight: '1px solid rgba(29, 50, 153, 0.1)',
    alignItems: 'center',
    svg: {
      display: 'inline-block',
      verticalAlign: 'middle',
    },
    '.MuiLink-root': {
      svg: {
        path: {
          fill: '#2845D2',
        },
      },
    },
    '.MuiIconButton-root': {
      marginRight: '15px',
      width: '30px',
      height: '30px',
      background: 'rgba(40, 69, 210, 0)',
      color: '#D5D4D4',
      '&:hover': {
        color: '#4B4B4B',
        background: 'rgba(75, 75, 75, 0.1)',
      },
    },
  },
});

export default styles;
